export function preventMinusKey(event: KeyboardEvent) {
  if (event.key === "-") {
    event.preventDefault();
  }
}

export function preventMinusPaste(event: ClipboardEvent) {
  if (event.clipboardData?.getData("text").includes("-")) {
    event.preventDefault();
  }
}
